import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const TermService = {
  LanguageGetAll,
  TermsGetAll,
  TermsById
};

async function LanguageGetAll() {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    }
  };

  const response = await fetch(
    `${config.oat_api_url}/user/languages/getAll/`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function TermsGetAll() {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    }
  };

  const response = await fetch(
    `${config.oat_api_url}/user/accept-terms/getAll/`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function TermsById(id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/user/accept-terms/get/${id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
